import { KeywordMapValidator } from '../Vaildator/KeywordMapValidator';
import _ from 'lodash';

export function KeywordMapEditRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.KeywordMapEdit', {
		url: '/keyword_map/edit',
		controllerAs: 'vm',
		controller: KeywordMapEditCtrl,
		templateUrl: '/ng/hub/KeywordMap/Edit/KeywordMapEditCtrl.html?' + window.BUILD,
		resolve: {},
	});
}

export class KeywordMapEditCtrl {
	// note: map is injected by modalService
	constructor($scope, modal, Api, Identity, map) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.modal = modal;
		// save map data
		this.origMap = map;
		this.map = _.cloneDeep(map);
		// setup scope based on current values
		if (this.map.hub_id) {
			this.scope = 'hub';
		} else if (this.map.account_id) {
			this.scope = 'account';
		} else {
			this.scope = 'system';
		}
	}

	cancel() {
		this.$reject();
	}

	save() {
		const scopeVars = {
			modal: this.modal,
			scope: this.scope,
			map: this.map,
			hubId: this.map.hub_id,
			accountId: this.map.account_id,
		};
		if (!KeywordMapValidator.isValid(scopeVars)) {
			return;
		}
		this.Api.patchDifference(`/keyword_maps/${this.map.id}`, this.origMap, this.map).then(
			() => {
				this.$resolve({ refresh: true });
			},
			() => {}
		);
	}

	delete() {
		this.modal.confirm({ text: 'Are you sure you want to delete this vocabulary word?' }).then(
			() => {
				this.Api.delete(`/keyword_maps/${this.map.id}`).then(
					() => {
						this.$resolve({ refresh: true });
					},
					() => {}
				);
			},
			() => {}
		);
	}
}
